import * as React from 'react';

// http://ux.bentley.com/bwc/layouts/full-page-error.html
export const SvgGenericErrorPage = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 428.65 258.125" {...props}>
    <path
      fill="#ffc335"
      d="M94.484 156.02l-6.663-13.928-3.13 2.728-3.125 2.737-3.129 2.727-3.125 2.737-2.62 2.285 2.011 4.204 3.423-.607 4.092-.716 4.087-.726 4.092-.716 4.087-.725z"
    />
    <path
      fill="#ffdb86"
      d="M87.93 137.687l10.051 21.007-1.804.863-10.05-21.007z"
    />
    <path
      fill="#fff"
      d="M84.691 144.82l5.706 11.925-4.092.716-4.739-9.904 3.125-2.737zM78.437 150.284l3.781 7.903-4.092.716-2.814-5.882 3.125-2.737z"
    />
    <path fill="#ffdb86" d="M221.982 192.509h32.373v32.373h-32.373z" />
    <path fill="#9aa4ad" d="M142.056 192.509h32.373v32.373h-32.373z" />
    <path
      d="M29.055 224.881H93.8v32.373H29.055zM61.412 192.5h64.745v-32.373H61.412zm80.644 32.382v32.373h64.745V224.88zm48.559-97.132h-32.373v32.372h32.373z"
      fill="#c6cacf"
    />
    <path fill="#ffc335" d="M158.525 160.122h15.9v32.38h-15.9z" />
    <path
      fill="#ffdb86"
      d="M109.987 127.749h48.255v32.373h-48.255zM45.544 192.506h48.255v32.373H45.544z"
    />
    <path
      d="M271.546 224.881v32.373h-64.745v-32.368H174.43V160.14l32.373-.008 15.18 15.189v49.561z"
      fill="#edeff2"
    />
    <path
      fill="#ffdb86"
      d="M142.056 208.392l-15.883-15.891-32.373.008v64.747h48.256v-48.864z"
    />
    <path
      d="M381.445 21.273H227.227a1 1 0 0 1-.707-1.708L245.792.293A1 1 0 0 1 246.5 0h115.976a1.002 1.002 0 0 1 .713.298l18.676 18.974h32.504a1 1 0 0 1 0 2h-32.923zm-151.803-2h149.415L362.056 2H246.913z"
      fill="#9aa4ad"
    />
    <path
      fill="#edeff2"
      d="M236.968 62.283h1V74.81h-1zM234.907 24.961h1v32.154h-1z"
    />
    <circle cx={237.468} cy={57.039} r={5.243} fill="#c6cacf" />
    <circle cx={239.514} cy={57.039} r={1.311} fill="#edeff2" />
    <path
      d="M234.322 57.04a5.245 5.245 0 0 1 4.195-5.139 5.243 5.243 0 1 0 0 10.276 5.245 5.245 0 0 1-4.195-5.138z"
      fill="#9aa4ad"
    />
    <path
      fill="#c6cacf"
      d="M383.084 257.417h-2V25.961h-25.167v231.456h-2V23.961h29.167v233.456z"
    />
    <path
      fill="#9aa4ad"
      d="M353.917 23.961h-10.109v233.456h2V25.961h8.109v-2z"
    />
    <path
      d="M383.084 40.072v-16.11h-29.167v233.456h2v-.04l.227.227 12.357-12.357 12.876 12.877.707-.707h1V40.072zm-26.753 108.676l12.17-12.17 12.17 12.17-12.17 12.169zm24.34 27.167l-12.17 12.17-12.17-12.17 12.17-12.17zm-24.34-54.335l12.17-12.17 12.169 12.17-12.17 12.17zm0-27.168l12.17-12.17 12.17 12.17-12.17 12.17zm0-27.167l12.17-12.17 12.17 12.17-12.17 12.17zm0-27.168l12.17-12.17 12.17 12.17-12.17 12.17zm10.756 13.584l-11.17 11.17v-22.34zm0 27.168l-11.17 11.17v-22.34zm0 27.167l-11.17 11.17v-22.34zm0 27.168l-11.17 11.17v-22.34zm0 27.168l-11.17 11.169v-22.34zm0 27.167l-11.17 11.17v-22.34zm-10.756 13.584l12.17-12.17 12.17 12.17-12.17 12.17zm10.756 13.583l-11.17 11.17v-22.34zm13.997-11.169v22.339l-11.17-11.17zm-11.17-15.998l11.17-11.17v22.34zm0-27.167l11.17-11.17v22.339zm0-27.168l11.17-11.17v22.34zm0-27.168l11.17-11.17v22.34zm0-27.167l11.17-11.17v22.339zm0-27.168l11.17-11.17v22.34zm11.17-15.999l-11.17-11.169.533-.532h10.637zm-14.53-11.7l.533.532-11.17 11.169V25.96zm-10.637 229.042v-22.34l11.17 11.17zm.414-24.754l12.17-12.17 12.169 12.17-12.17 12.17zm24.753 2.414v22.34l-11.17-11.17z"
      fill="#c6cacf"
    />
    <path fill="#ffdb86" d="M368.249 31.037h27.671v43.277h-27.671z" />
    <path fill="#fff" d="M390.765 38.036v14.64h-17.361v-14.64z" />
    <path fill="#ffc335" d="M360.972 31.037h7.277v43.277h-7.277z" />
    <path fill="#c6cacf" d="M360.972 74.284h34.948v2h-34.948z" />
    <path fill="#9aa4ad" d="M360.972 74.284h7.277v2h-7.277z" />
    <path fill="#edeff2" d="M239.029 26.222h1v30.893h-1z" />
    <path fill="#9aa4ad" d="M250.2 21.273h9.004v5.702H250.2z" />
    <path
      d="M426.562 19.273h-22.84L385.048.297a1.002 1.002 0 0 0-.713-.298H269.662a1.007 1.007 0 0 0-.707.293l-18.893 18.893h-22.695a1.198 1.198 0 0 0-1.198 1.198v6.59H250.2v-5.701h176.362a1 1 0 0 0 0-2zM329.976 2h16.172l-8.476 8.476-8.086-8.086zm-19.001 0h15.393l.39.39-8.086 8.086-8.087-8.086zm-19 0h15.392l.39.39-8.085 8.086-8.087-8.086zm-3.218.39l-9.535 9.535-9.535-9.535.39-.39h18.29zm-35.953 16.883l15.469-15.47 9.535 9.536-5.934 5.934zm21.898 0l4.52-4.52 4.52 4.52zm11.867 0l-5.933-5.934 9.535-9.535 8.086 8.086-7.383 7.383zm7.133 0l5.97-5.97 5.968 5.97zm14.766 0l-7.383-7.383 8.086-8.086 8.086 8.086-7.382 7.383zm4.235 0l5.969-5.969 5.968 5.969zm14.765 0l-7.382-7.383 8.086-8.086 8.086 8.086-7.383 7.383zm4.235 0l5.97-5.97 5.968 5.97zm14.766 0l-7.383-7.383 9.89-9.89h14.879l-17.273 17.273zm2.941 0L366.683 2h17.232l17.001 17.273z"
      fill="#c6cacf"
    />
    <path fill="#ffdb86" d="M126.157 160.126h32.373v32.373h-32.373z" />
    <path fill="#ffc335" d="M77.905 192.512h15.9v32.37h-15.9z" />
    <path fill="#ffdb86" d="M45.536 192.509h32.373v32.373H45.536z" />
    <path
      fill="#ffdb86"
      d="M45.535 192.512h.02v32.37h-.02zM213.196 74.81h32.373v32.373h-32.373z"
    />
    <path
      fill="#ffc335"
      d="M245.568 74.81h16.172v32.373h-16.172zM142.355 127.742h15.9v32.37h-15.9z"
    />
    <path
      fill="#ffdb86"
      d="M109.979 127.744h32.373v32.373h-32.373zM126.155 160.122h.02v32.38h-.02z"
    />
    <path fill="#ffdb86" d="M109.975 127.742h.02v32.37h-.02z" />
    <path
      fill="#fff"
      d="M29.055 257.254v-32.373l16.489-.002v-32.373l15.868-.007v-32.373l48.575-.005v-32.372h80.628v32.372l16.187.01 15.18 15.188v17.19h32.373v32.372h17.191v32.373"
      opacity={0.5}
    />
    <path
      d="M270.546 257.254v-3.5a1 1 0 0 1 2 0v3.5c0 .552-2 .552-2 0zM271.546 246.297a1 1 0 0 1-1-1v-8.457a1 1 0 1 1 2 0v8.457a1 1 0 0 1-1 1zM271.546 229.382a1 1 0 0 1-1-1v-2.5h-2.5a1 1 0 0 1 0-2h3.5a1 1 0 0 1 1 1v3.5a1 1 0 0 1-1 1zM257.855 225.882h-3.5a1 1 0 0 1-1-1v-3.5a1 1 0 0 1 2 0v2.5h2.5a1 1 0 0 1 0 2zM254.355 213.924a1 1 0 0 1-1-1v-8.457a1 1 0 0 1 2 0v8.457a1 1 0 0 1-1 1zM254.355 197.008a1 1 0 0 1-1-1v-2.5h-2.5a1 1 0 0 1 0-2h3.5a1 1 0 0 1 1 1v3.5a1 1 0 0 1-1 1zM242.397 193.508h-8.457a1 1 0 0 1 0-2h8.457a1 1 0 0 1 0 2zM225.482 193.508h-3.5a1 1 0 0 1-1-1v-3.5a1 1 0 0 1 2 0v2.5h2.5a1 1 0 0 1 0 2zM221.982 183.174a1 1 0 0 1-1-1v-6.836a1 1 0 0 1 2 0v6.836a1 1 0 0 1-1 1zm-4.819-11.676a.998.998 0 0 1-.707-.293l-4.833-4.835a1 1 0 0 1 1.415-1.414l4.833 4.835a1 1 0 0 1-.708 1.707zm-9.665-9.67a.998.998 0 0 1-.707-.293l-.403-.404-5.437-.003a1 1 0 0 1 0-2l5.851.004a1 1 0 0 1 .707.292l.696.697a1 1 0 0 1-.707 1.707zM194.115 161.124h-.001l-3.5-.003a1 1 0 0 1-1-1v-3.5a1 1 0 0 1 2 0v2.5l2.502.003a1 1 0 0 1-.001 2zM190.615 149.164a1 1 0 0 1-1-1v-8.457a1 1 0 0 1 2 0v8.457a1 1 0 0 1-1 1zM190.615 132.249a1 1 0 0 1-1-1v-2.5h-2.5a1 1 0 0 1 0-2h3.5a1 1 0 0 1 1 1v3.5a1 1 0 0 1-1 1zM181.406 128.749h-5.71a1 1 0 0 1 0-2h5.71a1 1 0 0 1 0 2zM169.987 128.749h-3.5a1 1 0 0 1-1-1v-3.5a1 1 0 0 1 2 0v2.5h2.5a1 1 0 1 1 0 2zM166.487 116.791a1 1 0 0 1-1-1v-8.457a1 1 0 0 1 2 0v8.457a1 1 0 0 1-1 1zM166.487 99.876a1 1 0 0 1-1-1v-2.5h-2.5a1 1 0 0 1 0-2h3.5a1 1 0 0 1 1 1v3.5a1 1 0 0 1-1 1zM154.53 96.376h-8.458a1 1 0 0 1 0-2h8.458a1 1 0 0 1 0 2zM134.115 99.876a1 1 0 0 1-1-1v-3.5a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2h-2.5v2.5a1 1 0 0 1-1 1zM134.115 116.791a1 1 0 0 1-1-1v-8.457a1 1 0 0 1 2 0v8.457a1 1 0 0 1-1 1zM134.115 128.749h-3.5a1 1 0 0 1 0-2h2.5v-2.5a1 1 0 1 1 2 0v3.5a1 1 0 0 1-1 1zM124.905 128.749h-5.71a1 1 0 0 1 0-2h5.71a1 1 0 1 1 0 2zM109.987 132.249a1 1 0 0 1-1-1v-3.5a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2h-2.5v2.5a1 1 0 0 1-1 1zM109.987 149.164a1 1 0 0 1-1-1v-8.457a1 1 0 0 1 2 0v8.457a1 1 0 0 1-1 1zM106.487 161.122a1 1 0 0 1 0-2l2.5-.001v-2.5a1 1 0 0 1 2 0v3.5a1 1 0 0 1-1 1zM70.852 161.126a1 1 0 0 1 0-2l5.939-.001a1 1 0 0 1 0 2zm11.878-.001a1 1 0 0 1 0-2l5.94-.001a1 1 0 0 1 0 2zm11.879-.001a1 1 0 0 1 0-2l5.939-.001a1 1 0 1 1 0 2zM61.413 164.627a1 1 0 0 1-1-1v-3.5a1 1 0 0 1 1-1l3.5-.001a1 1 0 0 1 0 2h-2.5v2.5a1 1 0 0 1-1 1zM61.413 181.54a1 1 0 0 1-1-1v-8.456a1 1 0 0 1 2 0v8.457a1 1 0 0 1-1 1zM57.913 193.5a1 1 0 0 1 0-2h2.5v-2.501a1 1 0 0 1 2 0v3.5a1 1 0 0 1-1 1l-3.5.002zM45.544 197.007a1 1 0 0 1-1-1v-3.5a1 1 0 0 1 1-1l3.5-.002a1 1 0 0 1 0 2h-2.5v2.502a1 1 0 0 1-1 1zM45.544 213.92a1 1 0 0 1-1-1v-8.456a1 1 0 0 1 2 0v8.457a1 1 0 0 1-1 1zM42.045 225.88a1 1 0 0 1-.001-2h2.5v-2.5a1 1 0 0 1 2 0v3.5a1 1 0 0 1-1 1zM29.055 229.382a1 1 0 0 1-1-1v-3.5a1 1 0 0 1 1-1l3.5-.001a1 1 0 1 1 0 2h-2.5v2.5a1 1 0 0 1-1 1zM29.055 246.296a1 1 0 0 1-1-1v-8.457a1 1 0 0 1 2 0v8.457a1 1 0 0 1-1 1zM28.055 257.254v-3.5a1 1 0 0 1 2 0v3.5c0 .552-2 .552-2 0z"
      fill="#84919c"
    />
    <path
      d="M270.55 219.357v10.049h2v-10.05a2.622 2.622 0 1 0-2 0zM272.549 254.898v-17.362h-2v17.362h-3.787v2h9.574v-2h-3.787zM308.06 219.356v8.892h2v-8.891a2.622 2.622 0 1 0-2 0zM310.059 254.898v-15.073h-2v15.073h-3.787v2h9.575v-2h-3.788z"
      fill="#c6cacf"
    />
    <rect
      x={260.579}
      y={235.26}
      width={59.406}
      height={9.13}
      rx={1}
      fill="#ffc335"
    />
    <rect
      x={260.579}
      y={221.565}
      width={59.406}
      height={9.13}
      rx={1}
      fill="#ffc335"
    />
    <path
      fill="#fff"
      d="M311.847 235.26h3l4.18 9.131h-3l-4.18-9.131zM303.469 235.26h3l4.181 9.131h-3l-4.181-9.131zM295.091 235.26h3l4.181 9.131h-3l-4.181-9.131zM286.714 235.26h3l4.181 9.131h-3l-4.181-9.131zM278.336 235.26h3l4.181 9.131h-3l-4.181-9.131zM269.959 235.26h3l4.181 9.131h-3l-4.181-9.131zM261.581 235.26h3l4.181 9.131h-3l-4.181-9.131zM311.847 221.565h3l4.18 9.13h-3l-4.18-9.13zM303.469 221.565h3l4.181 9.13h-3l-4.181-9.13zM295.091 221.565h3l4.181 9.13h-3l-4.181-9.13zM286.714 221.565h3l4.181 9.13h-3l-4.181-9.13zM278.336 221.565h3l4.181 9.13h-3l-4.181-9.13zM269.959 221.565h3l4.181 9.13h-3l-4.181-9.13zM261.581 221.565h3l4.181 9.13h-3l-4.181-9.13z"
    />
    <path fill="#4d5860" d="M0 256.898h428.65v1H0z" />
  </svg>
);
export default SvgGenericErrorPage;
